import { logError } from './logger';

/**
 * 前端的錯誤回報。
 *
 * 跟後端同一個原則：沒設定 DSN 就完全 no-op。SDK 用動態 import，沒設定的部署連載都不會
 * 載——那是一包不小的東西，不該讓每個使用者為了一個沒開的功能多下載它。
 */

let capture: ((error: unknown) => void) | null = null;

export async function initErrorReporting(): Promise<void> {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (dsn === undefined || dsn === '') {
    return;
  }

  try {
    const Sentry = await import('@sentry/react');

    Sentry.init({ dsn, environment: import.meta.env.MODE });
    capture = (error: unknown) => Sentry.captureException(error);
  } catch (error) {
    // 錯誤追蹤載不起來不該讓整個 app 起不來
    logError('錯誤追蹤初始化失敗', error);
  }
}

export function reportError(error: unknown): void {
  capture?.(error);
}
